import { createSlice } from '@reduxjs/toolkit'
import { toFloat } from "../../toolbox";

export const contractSlice = createSlice({
  name: 'contract',
  initialState: {
    sections: {
      Basicdata:    { edit: false, disabled: false, maximized: true, sticky: false },
      SeasonRooms:  { edit: false, disabled: false, maximized: true, sticky: false },
      Boards:       { edit: false, disabled: false, maximized: true, sticky: false },
      Specials:     { edit: false, disabled: false, maximized: true, sticky: false },
      AddSpecials:  { edit: false, disabled: false, maximized: true, sticky: false },
      HeadOffice:   { edit: false, disabled: false, maximized: true, sticky: false },
      Comments:     { edit: false, disabled: false, maximized: true, sticky: false },
    },

    isEditMode: false,
    isDirty: false,
    isSidebar: false,
    isLoaded: false,

    availableSeasonKeys: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    maxSeasonsVisible: 8,

    NewRoom: {
      RoomId: '__NEW__',
      RoomCode: '',
      RoomName: '',
      Allotment: { Type: "X" },
      Occupancy: {
        FullPaying: '',
        PaxMin: '',
        PaxMax: '',
        AdultMin: '',
        AdultMax: '',
        ChildrenMin: '',
        ChildrenMax: ''
      },
      LockedOccupancies: [],
      AdultOnly: {},
      Infants: {},
      Allotments: [],
      Board: null,
      Prices: [],
      BoardCharges: {},
      Reductions: [
        {
          Board: null,
          Type: "C",
          ChildNumber: 1,
          ChildAgeFrom: 2,
          ChildAgeTo: 5,
          Reductions: []
        },
        {
          Board: null,
          Type: "C",
          ChildNumber: 1,
          ChildAgeFrom: 6,
          ChildAgeTo: 12,
          Reductions: []
        },
        {
          Board: null,
          Type: "C",
          ChildNumber: 2,
          ChildAgeFrom: 2,
          ChildAgeTo: 12,
          Reductions: []
        },
        {
          Board: null,
          Type: "A",
          Reductions: []
        }
      ]
    },

    data: {
      Contract: null,
      data: null,
      Original: null,
      Changes: [],
      currentChangeNr: 0,
      meta: null,
      Options: {
        lastSeasonKey: 'F',
        maxSeasonRows: 2,
        isSeasonWeekdays: true
      },
      AllSeasons: []
    },

    details: {}
  },



  reducers: {
    maximizeSection: (state, action)      => { state.sections[action.payload].maximized = true;},
    minimizeSection: (state, action)      => { state.sections[action.payload].maximized = false; },
    stickSection: (state, action)         => { state.sections[action.payload].sticky = true; },
    unstickSection: (state, action)       => { state.sections[action.payload].sticky = false; },
    setDirty: (state, action)             => { state.isDirty = action.payload; },
    showSidebar: (state)                  => { state.isSidebar = true },
    hideSidebar: (state)                  => { state.isSidebar = false },
    setContractIsLoaded: (state, action)  => { state.isLoaded = action.payload; },
    setEditMode: (state, action) => {
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = true;
      });
      state.sections[action.payload].edit = true;
      state.sections[action.payload].disabled = false;
    },
    setReadonlyMode: (state, action) => {
      state.sections[action.payload].edit = false;
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = false;
      });
    },


    startEdit: (state, action) => {
      if (state.data.Original === null) {
        state.data.Original = state.data.Contract;
      }

      // switch  to edit mode
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = true;
      });
      state.sections[action.payload].edit = true;
      state.sections[action.payload].disabled = false;
    },

    confimEdit: (state, action) => {
      state.data.Changes.push(state.data.Contract);
      state.isDirty = true;
      state.data.currentChangeNr = state.data.Changes.length;

      // switch back to readonly mode
      state.sections[action.payload].edit = false;
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = false;
      });
    },

    abortEdit: (state, action) => {
      state.data.Changes = [];
      state.isDirty = false;
      state.data.currentChangeNr = 0;
      if (state.data.Original !== null) {
        state.data.Contract = state.data.Original;
      }

      // switch back to readonly mode
      if (typeof state.sections[action.payload] !== 'undefined') {
        state.sections[action.payload].edit = false;
      }
      Object.keys(state.sections).forEach(key => {
        state.sections[key].disabled = false;
      });
    },

    deleteFromChanges: (state, action)  => { 
      if (typeof action.payload && !isNaN(action.payload)) {
        state.data.Changes.slice(action.payload, 1);
      } else {
        state.data.Contract = state.data.Changes.pop();
      }
      if (!state.data.Changes.length) {
        state.isDirty = false;  
      }
    },

    deleteLastChange: (state) => { 
      state.data.Changes.pop();
      if (state.data.Changes.length) {
        state.data.Contract = state.data.Changes[state.data.Changes.length - 1];
        state.data.currentChangeNr = state.data.Changes.length;
      } else {
        state.data.Contract = state.data.Original;
        state.isDirty = false;
        state.data.currentChangeNr = 0;
      }
    },

    deleteAllChanges: (state) => { 
      state.data.Contract = state.data.Original;
      state.data.Changes = [];
      state.isDirty = false;
    },

    confimChanges: (state) => {
      state.data.Changes = [];
      state.isDirty = false;
      state.data.currentChangeNr = 0;
    },

    resetObject: (state) => {
      state.isDirty = false;
      state.data.Changes = [];
      state.data.Contract = state.data.Original;
      state.data.Original = null;
      state.data.currentChangeNr = 0;
    },







    setContractData: (state, action) => {
      switch (action.payload.target) {
        case 'ALL': state.data.Contract = action.payload.value; break;

        case 'Basics.Season':       state.data.Contract.Basics.Season = action.payload.value; break;
        case 'Basics.Destination':  state.data.Contract.Basics.Destination = action.payload.value; break;
        case 'Basics.Hotelname':    state.data.Contract.Basics.Hotelname = action.payload.value; break;
        case 'Basics.Hotelchain':   state.data.Contract.Basics.Hotelchain = action.payload.value; break;
        case 'Basics.AgencyCode':   state.data.Contract.Basics.AgencyCode = action.payload.value; break;
        case 'Basics.TONumber':     state.data.Contract.Basics.TONumber = action.payload.value; break;
        case 'Basics.TLeistung':    state.data.Contract.Basics.TLeistung = action.payload.value; break;
        case 'Basics.CategoryOff':  state.data.Contract.Basics.CategoryOff = action.payload.value; break;
        case 'Basics.CategoryInt':  state.data.Contract.Basics.CategoryInt = action.payload.value; break;
        case 'Basics.HotelType':    state.data.Contract.Basics.HotelType = action.payload.value; break;

        case 'Basics.Contact.Street':     state.data.Contract.Basics.Contact.Street = action.payload.value; break;
        case 'Basics.Contact.Postcode':   state.data.Contract.Basics.Contact.Postcode = action.payload.value; break;
        case 'Basics.Contact.City':       state.data.Contract.Basics.Contact.City = action.payload.value; break;
        case 'Basics.Contact.Country':    state.data.Contract.Basics.Contact.Country = action.payload.value; break;
        case 'Basics.Contact.Phone':      state.data.Contract.Basics.Contact.Phone = action.payload.value; break;
        case 'Basics.Contact.Fax':        state.data.Contract.Basics.Contact.Fax = action.payload.value; break;
        case 'Basics.Contact.Email':      state.data.Contract.Basics.Contact.Email = action.payload.value; break;
        case 'Basics.Contact.Web':        state.data.Contract.Basics.Contact.Web = action.payload.value; break;



        case 'Period.Start': state.data.Contract.Period.Start = action.payload.value; break;
        case 'Period.End': state.data.Contract.Period.End = action.payload.value; break;
        case 'Currency': state.data.Contract.Currency = action.payload.value; break;

        case 'Rooms.Occupancy.FullPaying':      state.data.Contract.Rooms[action.payload.roomKey].Occupancy.FullPaying = action.payload.value; break;
        case 'Rooms.Occupancy.PaxMin':          state.data.Contract.Rooms[action.payload.roomKey].Occupancy.PaxMin = action.payload.value; break;
        case 'Rooms.Occupancy.PaxMax':          state.data.Contract.Rooms[action.payload.roomKey].Occupancy.PaxMax = action.payload.value; break;
        case 'Rooms.Occupancy.AdultMin':        state.data.Contract.Rooms[action.payload.roomKey].Occupancy.AdultMin = action.payload.value; break;
        case 'Rooms.Occupancy.AdultMax':        state.data.Contract.Rooms[action.payload.roomKey].Occupancy.AdultMax = action.payload.value; break;
        case 'Rooms.Occupancy.ChildrenMin':     state.data.Contract.Rooms[action.payload.roomKey].Occupancy.ChildrenMin = action.payload.value; break;
        case 'Rooms.Occupancy.ChildrenMax':     state.data.Contract.Rooms[action.payload.roomKey].Occupancy.ChildrenMax = action.payload.value; break;
        case 'Rooms.LockedOccupancies':         state.data.Contract.Rooms[action.payload.roomKey].LockedOccupancies = action.payload.value; break;
        case 'Rooms.AdultOnly.IsAdultOnly':     state.data.Contract.Rooms[action.payload.roomKey].AdultOnly.IsAdultOnly = action.payload.value; if (!action.payload.value) { state.data.Contract.Rooms[action.payload.roomKey].AdultOnly.AdultAge = 0} break;
        case 'Rooms.AdultOnly.AdultAge':        state.data.Contract.Rooms[action.payload.roomKey].AdultOnly.AdultAge = action.payload.value; break;
        case 'Rooms.Infants':                   state.data.Contract.Rooms[action.payload.roomKey].Infants = action.payload.value; break;

        case 'Rooms.Board':                     state.data.Contract.Rooms[action.payload.roomKey].Board = action.payload.value; break;
        case 'Rooms.Price':                     state.data.Contract.Rooms[action.payload.roomKey].Prices[action.payload.seasonKey] = { Amount: toFloat(action.payload.value) }; break;
        case 'Rooms.Allotment':                 state.data.Contract.Rooms[action.payload.roomKey].Allotments[action.payload.seasonKey] = { Amount: action.payload.value }; break;
        case 'Prices.Reduction.AllTheSame':     state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].AllTheSame = action.payload.value; break;
        case 'Prices.Reduction.ChildNumber':    state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildNumber = action.payload.value; break;
        case 'Prices.Reduction.ChildAgeFrom':   state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildAgeFrom = action.payload.value; break;
        case 'Prices.Reduction.ChildAgeTo':     state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildAgeTo = action.payload.value; break;
        case 'Prices.Reduction.Type':        
          state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[action.payload.seasonKey].Type = action.payload.value;
          if (state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.AllTheSame) {
            for (const skey in state.data.Contract.Seasons) {
              if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[skey] = { 
                  Type: action.payload.value, 
                  Value: state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[skey]?.Value
                };
              }

            }
          }
          break;
        case 'Prices.Reduction.Value':       
          state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[action.payload.seasonKey] = { 
            Type: state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[action.payload.seasonKey]?.Type, 
            Value: toFloat(action.payload.value)
          };
          if (state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.AllTheSame) {
            for (const skey in state.data.Contract.Seasons) {
              if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[skey] = { 
                  Type: state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[skey]?.Type, 
                  Value: toFloat(action.payload.value)
                };
              }
            }
          }
          break;
        case 'Prices.AdultReduction.AllTheSame':  state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.AllTheSame = action.payload.value; break;
        case 'Prices.AdultReduction.Type':        
          state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.Reductions[action.payload.seasonKey].Type = { 
            Type: action.payload.value,
            Value: state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[action.payload.seasonKey]?.Value
          };
          if (state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.AllTheSame) {
            for (const skey in state.data.Contract.Seasons) {
              if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.Reductions[skey] = { 
                  Type: action.payload.value, 
                  Value: state.data.Contract.Rooms[action.payload.roomKey].AdultReduction?.Reductions[skey]?.Value
                };
              }
            }
          }
          break;
        case 'Prices.AdultReduction.Value':       
          state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.Reductions[action.payload.seasonKey].Value = { 
            Value: toFloat(state.data.Contract.Rooms[action.payload.roomKey].AdultReduction?.Reductions[action.payload.seasonKey]?.Value)
          } 
          if (state.data.Contract.Rooms[action.payload.roomKey].AdultReduction?.AllTheSame) {
            for (const skey in state.data.Contract.Seasons) {
              if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                state.data.Contract.Rooms[action.payload.roomKey].AdultReduction.Reductions[skey] = { 
                  Type: state.data.Contract.Rooms[action.payload.roomKey].AdultReduction?.Reductions[skey]?.Type,
                  Value: toFloat(action.payload.value),
                };
              }
            }
          }
          break;

          case 'Boards.Room':                     state.data.Contract.Boards[action.payload.roomKey].Room = action.payload.value; break;
          case 'Boards.Board':                    state.data.Contract.Boards[action.payload.roomKey].Board = action.payload.value; break;
          case 'Boards.Price':                    state.data.Contract.Boards[action.payload.roomKey].Prices[action.payload.seasonKey] = { Amount: toFloat(action.payload.value) }; break;
          case 'Boards.Reduction.AllTheSame':     state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].AllTheSame = action.payload.value; break;
          case 'Boards.Reduction.ChildNumber':    state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildNumber = action.payload.value; break;
          case 'Boards.Reduction.ChildAgeFrom':   state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildAgeFrom = action.payload.value; break;
          case 'Boards.Reduction.ChildAgeTo':     state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].ChildAgeTo = action.payload.value; break;
          case 'Boards.Reduction.Type':        
            state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[action.payload.seasonKey].Type = action.payload.value;
            if (state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey]?.AllTheSame) {
              for (const skey in state.data.Contract.Seasons) {
                if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                  state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[skey] = { 
                    Type: action.payload.value, 
                    Value: state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[skey]?.Value
                  };
                }
  
              }
            }
            break;
          case 'Boards.Reduction.Value':       
            state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[action.payload.seasonKey] = { 
              Type: state.data.Contract.Rooms[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[action.payload.seasonKey]?.Type, 
              Value: toFloat(action.payload.value)
            };
            if (state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey]?.AllTheSame) {
              for (const skey in state.data.Contract.Seasons) {
                if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                  state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey].Reductions[skey] = { 
                    Type: state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[skey]?.Type, 
                    Value: toFloat(action.payload.value)
                  };
                }
              }
            }
            break;
          case 'Boards.AdultReduction.AllTheSame':  state.data.Contract.Boards[action.payload.roomKey].AdultReduction.AllTheSame = action.payload.value; break;
          case 'Boards.AdultReduction.Type':        
            state.data.Contract.Boards[action.payload.roomKey].AdultReduction.Reductions[action.payload.seasonKey].Type = { 
              Type: action.payload.value,
              Value: state.data.Contract.Boards[action.payload.roomKey].Reductions[action.payload.reductionKey]?.Reductions[action.payload.seasonKey]?.Value
            };
            if (state.data.Contract.Boards[action.payload.roomKey].AdultReduction.AllTheSame) {
              for (const skey in state.data.Contract.Seasons) {
                if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                  state.data.Contract.Boards[action.payload.roomKey].AdultReduction.Reductions[skey] = { 
                    Type: action.payload.value, 
                    Value: state.data.Contract.Boards[action.payload.roomKey].AdultReduction?.Reductions[skey]?.Value
                  };
                }
              }
            }
            break;
          case 'Boards.AdultReduction.Value':       
            state.data.Contract.Boards[action.payload.roomKey].AdultReduction.Reductions[action.payload.seasonKey].Value = { 
              Value: toFloat(state.data.Contract.Boards[action.payload.roomKey].AdultReduction?.Reductions[action.payload.seasonKey]?.Value)
            } 
            if (state.data.Contract.Boards[action.payload.roomKey].AdultReduction?.AllTheSame) {
              for (const skey in state.data.Contract.Seasons) {
                if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, skey)) {
                  state.data.Contract.Boards[action.payload.roomKey].AdultReduction.Reductions[skey] = { 
                    Type: state.data.Contract.Boards[action.payload.roomKey].AdultReduction?.Reductions[skey]?.Type,
                    Value: toFloat(action.payload.value),
                  };
                }
              }
            }
            break;

        case 'Seasons':         state.data.Contract.Seasons = action.payload.value; break;
        case 'Season.Start':    state.data.Contract.Seasons[action.payload.season][action.payload.row].Start = action.payload.value; break;
        case 'Season.End':      state.data.Contract.Seasons[action.payload.season][action.payload.row].End = action.payload.value; break;
        case 'Season.Weekday':  state.data.Contract.Seasons[action.payload.season][action.payload.row].Weekdays[action.payload.weekday] = action.payload.value; break;



        case 'StopSales.Rooms':   state.data.Contract.StopSales[action.payload.row].Rooms   = [action.payload.value]; break;
        case 'StopSales.Boards':  state.data.Contract.StopSales[action.payload.row].Boards  = [action.payload.value]; break;
        case 'StopSales.Start':   state.data.Contract.StopSales[action.payload.row].Start   = action.payload.value; break;
        case 'StopSales.End':     state.data.Contract.StopSales[action.payload.row].End     = action.payload.value; break;

        case 'Release.Start':     state.data.Contract.Release[action.payload.row].Start     = action.payload.value; break;
        case 'Release.End':       state.data.Contract.Release[action.payload.row].End       = action.payload.value; break;
        case 'Release.Value':     state.data.Contract.Release[action.payload.row].Value     = action.payload.value; break;
        case 'Release.Weekday':   state.data.Contract.Release[action.payload.row].Weekdays[action.payload.weekday] = action.payload.value; break;

        case 'Arrivals.Start':    state.data.Contract.Arrivals[action.payload.row].Start    = action.payload.value; break;
        case 'Arrivals.End':      state.data.Contract.Arrivals[action.payload.row].End      = action.payload.value; break;
        case 'Arrivals.Weekday':  state.data.Contract.Arrivals[action.payload.row].Weekdays[action.payload.weekday] = action.payload.value; break;
        
        case 'MaxStay.Start':     state.data.Contract.MaxStay[action.payload.row].Start    = action.payload.value; break;
        case 'MaxStay.End':       state.data.Contract.MaxStay[action.payload.row].End      = action.payload.value; break;
        case 'MaxStay.Value':     state.data.Contract.MaxStay[action.payload.row].Value    = action.payload.value; break;
        case 'MaxStay.Weekday':   state.data.Contract.MaxStay[action.payload.row].Weekdays[action.payload.weekday] = action.payload.value; break;

        case 'MinStay.Start':     state.data.Contract.MinStay[action.payload.row].Start    = action.payload.value; break;
        case 'MinStay.End':       state.data.Contract.MinStay[action.payload.row].End      = action.payload.value; break;
        case 'MinStay.Value':     state.data.Contract.MinStay[action.payload.row].Value    = action.payload.value; break;
        case 'MinStay.Weekday':   state.data.Contract.MinStay[action.payload.row].Weekdays[action.payload.weekday] = action.payload.value; break;

        case 'Special':
          let num;
          state.data.Contract.Extras.forEach((item, index) => {
            if (item.ExtraId === action.payload.ExtraId) {
              num = index;
            }
          });
          if (typeof num !== 'undefined') {
            state.data.Contract.Extras[num] = action.payload.value;
          } else {
            state.data.Contract.Extras.push(action.payload.value);
          }
          break;

        case 'PDF':               state.data.Contract.PDF = action.payload.value; break;
        case 'EDF':               state.data.Contract.EDF = action.payload.value; break;

        case 'Status':            state.data.Contract.Status.STATUS = action.payload.value; break;

        case 'Link.Sub':          state.data.Contract.Links.SubContracts.push(action.payload.value); break;
        case 'Unlink.Sub':
          let _links = [];
          let _unlink = typeof state.data.Contract?.Unlink !== 'undefined' ? state.data.Contract?.Unlink : [];
          state.data.Contract.Links.SubContracts.forEach(link => {
            if (link.id !== action.payload.value) {
              _links.push(link);
            } else {
              _unlink.push(link);
            }
            
          });
          state.data.Contract.Links.SubContracts = _links; 
          state.data.Contract.Unlink = _unlink; 
          break;

        default: break;
      }
    },





    doContractAction: (state, action) => {
      switch (action.payload.target) {

        // Add season column
        case 'Room.addRoom':
          let _addrooms = JSON.parse(JSON.stringify(state.data.Contract.Rooms));
          _addrooms.push(action.payload.value)
          state.data.Contract.Rooms = _addrooms;
          break;
        
        case 'Room.delRoom':
          let _delrooms = JSON.parse(JSON.stringify(state.data.Contract.Rooms));
          _delrooms.splice(action.payload.value, 1);
          state.data.Contract.Rooms = _delrooms;
          break;

        // Add season column
        case 'Season.addSeason':
          const nextSeasonKey = state.availableSeasonKeys[state.availableSeasonKeys.lastIndexOf(state.data.Options.lastSeasonKey) + 1];
          state.data.Options.lastSeasonKey = nextSeasonKey;
          let newSeason = [];
          for (let index = 0; index < state.data.Options.maxSeasonRows; index++) {
            newSeason.push({Start: null, End: null});
          }
          state.data.Contract.Seasons[nextSeasonKey] = newSeason;
          break;

        // Delete season column
        case 'Season.delSeason':
          const prevSeasonKey = state.availableSeasonKeys[state.availableSeasonKeys.lastIndexOf(state.data.Options.lastSeasonKey) - 1];
          delete state.data.Contract.Seasons[state.data.Options.lastSeasonKey];
          state.data.Options.lastSeasonKey = prevSeasonKey;
          /* 
          Todo: checken ob alle Saison-Zeilen auch mit Datumsangaben befüllt sind. Ansonsten ggf. leere Saisonzeilen löschen
          */
          break;

        // Add season row
        case 'Season.addSeasonRow':
          Object.keys(state.data.Contract.Seasons).forEach(seasonKey => {
            state.data.Contract.Seasons[seasonKey].push({Start: null, End: null})
          });
          state.data.Options.maxSeasonRows++;
          break;

        // Delete season row
        case 'Season.delSeasonRow':
          Object.keys(state.data.Contract.Seasons).forEach(seasonKey => {
            if (typeof state.data.Contract.Seasons[seasonKey][(state.data.Options.maxSeasonRows-1)] !== 'undefined') {
              state.data.Contract.Seasons[seasonKey].pop()
            }
          });
          state.data.Options.maxSeasonRows--;
          break;

        // Add child reduction row
        case 'Prices.addChildRow':
          const lastReductionKey = state.data.Contract.Rooms[action.payload.roomKey].Reductions.length - 1;
          const childNumber   = lastReductionKey > -1 ? state.data.Contract.Rooms[action.payload.roomKey].Reductions[lastReductionKey].ChildNumber : 5;
          const childAgeFrom  = lastReductionKey > -1 ?  parseInt(state.data.Contract.Rooms[action.payload.roomKey].Reductions[lastReductionKey].ChildAgeTo) + 1 : 2;
          const childAgeTo    = lastReductionKey > -1 ? (childAgeFrom < 12 ? 12 : 18) : 12;
          state.data.Contract.Rooms[action.payload.roomKey].Reductions.push(
            {
              ChildNumber: childNumber,
              ChildAgeFrom: childAgeFrom,
              ChildAgeTo: childAgeTo,
              AllTheSame: false,
              Reductions: {}
            },
          );
          break;

        // Delete child reduction row
        case 'Prices.delChildRow':
          state.data.Contract.Rooms[action.payload.roomKey].Reductions.pop();
          break;
        
        // Show adult reduction row
        case 'Prices.addAdultRow':
          state.data.Contract.Rooms[action.payload.roomKey].AdultReduction = {
            AllTheSame: false,
            Reductions: {}
          };
          
          break;
        
        // Remove adult reduction row
        case 'Prices.delAdultRow':
          state.data.Contract.Rooms[action.payload.roomKey].AdultReduction = null;
          break;

        // Boards - Add child reduction row
        case 'Boards.addChildRow':
          const boardlastReductionKey = state.data.Contract.Boards[action.payload.roomKey].Reductions.length - 1;
          const boardchildNumber   = boardlastReductionKey > -1 ? state.data.Contract.Boards[action.payload.roomKey].Reductions[boardlastReductionKey].ChildNumber : 5;
          const boardchildAgeFrom  = boardlastReductionKey > -1 ?  parseInt(state.data.Contract.Boards[action.payload.roomKey].Reductions[boardlastReductionKey].ChildAgeTo) + 1 : 2;
          const boardchildAgeTo    = boardlastReductionKey > -1 ? (boardchildAgeFrom < 12 ? 12 : 18) : 12;
          state.data.Contract.Boards[action.payload.roomKey].Reductions.push(
            {
              ChildNumber: boardchildNumber,
              ChildAgeFrom: boardchildAgeFrom,
              ChildAgeTo: boardchildAgeTo,
              AllTheSame: false,
              Reductions: {}
            },
          );
          break;

        // Boards - Delete child reduction row
        case 'Boards.delChildRow':
          state.data.Contract.Boards[action.payload.roomKey].Reductions.pop();
          break;
        
        // Boards - Show adult reduction row
        case 'Boards.addAdultRow':
          state.data.Contract.Boards[action.payload.roomKey].AdultReduction = {
            AllTheSame: false,
            Reductions: {}
          };
          
          break;
        
        // Boards - Remove adult reduction row
        case 'Boards.delAdultRow':
          state.data.Contract.Boards[action.payload.roomKey].AdultReduction = null;
          break;


        // Boards - add row
        case 'Boards.addBoardRow':
          let newBoardObject = {
              "Board": null,
              "Room": null,
              "Prices": {},
              "Reductions": [],
              "AdultReduction": null
          }
          for (const key in state.data.Contract.Seasons) {
            if (Object.prototype.hasOwnProperty.call(state.data.Contract.Seasons, key)) {
              newBoardObject.Prices[key] = { Amount: 0 }  
            }
          }
          state.data.Contract.Boards.push(newBoardObject);
          break;

          

        // Specials - add 
        case 'Special.add':
          let newExtra = {
            ExtraId     : '__NEW__',
            ExtraGroup  : action.payload.group,
            ExtraType   : action.payload.type,
            ExtraText   : '',
            Information : '',
            Restrictions: {
              Dates: [
                {
                  Period: { Start: state.data.Contract.Period.Start, End: state.data.Contract.Period.End },
                }
              ],
              Bookings: [
                [
                  {
                    Period : {
                        Start : null,
                        End   : null
                    },
                    MinBookingOffset : {
                        Type   : null,
                        Value  : null,
                        Period : 'D'
                    }
                  }
                ]
              ],
              Rooms: [],
              Boards: []
            }
          };

          state.data.Contract.Extras.push(newExtra);
          break;

        // Specials - remove 
        case 'Special.remove':
          let index = state.data.Contract.Extras.findIndex((extra) => extra.ExtraId === action.payload.value);
          if (index !== -1) {
            state.data.Contract.Extras.splice(index, 1);
          }
          break;

        // Specials - copy 
        case 'Special.copy':
          let extra_id = action.payload.value;
          state.data.Contract.Extras.forEach((extra) => {
            if (extra.ExtraId === extra_id) {
              let newExtra = JSON.parse(JSON.stringify(extra));
              newExtra.ExtraId = '__NEW__';
              state.data.Contract.Extras.push(newExtra);
            }
          });
          break;



        // Headoffice 
        case 'MinStay.addRow':      state.data.Contract.MinStay.push({Additional: !action.payload.value, Start: null, End: null, Weekdays: {mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true }, value: ''}); break;
        case 'MaxStay.addRow':      state.data.Contract.MaxStay.push({Additional: !action.payload.value, Start: null, End: null, Weekdays: {mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true }, value: ''}); break;
        case 'Arrivals.addRow':     state.data.Contract.Arrivals.push({Additional: !action.payload.value, Start: null, End: null, Weekdays: {mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true }}); break;
        case 'Release.addRow':      state.data.Contract.Release.push({Additional: !action.payload.value, Start: null, End: null, Weekdays: {mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true }, value: ''}); break;
        case 'StopSale.addRow':     state.data.Contract.StopSales.push({Additional: !action.payload.value, Start: null, End: null, Weekdays: {mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true }, Rooms: [], Boards: []}); break;

        case 'MinStay.deleteRow':   state.data.Contract.MinStay.splice(action.payload.value, 1); break;
        case 'MaxStay.deleteRow':   state.data.Contract.MaxStay.splice(action.payload.value, 1); break;
        case 'Arrivals.deleteRow':  state.data.Contract.Arrivals.splice(action.payload.value, 1); break;
        case 'Release.deleteRow':   state.data.Contract.Release.splice(action.payload.value, 1); break;
        case 'StopSale.deleteRow':  state.data.Contract.StopSales.splice(action.payload.value, 1); break;

        case 'MinStay.copyRow':     state.data.Contract.MinStay.push(state.data.Contract.MinStay[action.payload.value]); break;
        case 'MaxStay.copyRow':     state.data.Contract.MaxStay.push(state.data.Contract.MaxStay[action.payload.value]); break;
        case 'Arrivals.copyRow':    state.data.Contract.Arrivals.push(state.data.Contract.Arrival[action.payload.value]); break;
        case 'Release.copyRow':     state.data.Contract.Release.push(state.data.Contract.Release[action.payload.value]); break;
        case 'StopSale.copyRow':    state.data.Contract.StopSales.push(state.data.Contract.StopSales[action.payload.value]); break;

        default:  break;
      }
    },




    setContractOptions: (state, action) => {
      switch (action.payload.target) {
        case 'isSeasonWeekdays': state.data.Options.isSeasonWeekdays = action.payload.value;  break;

        default: break;
      }
    },


    setContractSeasons: (state, action) => {
      state.data.AllSeasons = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { 
  setEditMode, 
  setReadonlyMode, 
  setDirty, 
  maximizeSection, 
  minimizeSection, 
  setContractData, 
  doContractAction, 
  setContractOptions, 
  stickSection, 
  unstickSection, 
  showSidebar, 
  hideSidebar, 
  setContractIsLoaded,
  setContractSeasons,

  setCurrentChangeNr,
  deleteFromChanges,
  deleteAllChanges,
  deleteLastChange,
  confimChanges,
  startEdit,
  confimEdit,
  abortEdit,
  resetObject
} = contractSlice.actions

export default contractSlice.reducer